import React from 'react';
import { Button as TWButton } from './tailwindButton';

export const Button = ({ ...props }) => <TWButton {...props} />;

export default Button;
